import { QueryKeys } from '@/configs/queryKeys';
import { UUID, Translations } from '@/types/types';
import { ComponentCategory } from './ComponentCategoryApi';
import { QueryFunctionContext } from '@tanstack/react-query';
import { AttributeValue } from './AttributeValueApi';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export enum AttributeType {
	SEGMENT_CONTROL,
	WITH_IMAGE,
	SELECT,
}

export interface Attribute extends BaseEntity {
	name: string;
	description: string;
	listOrder: number;
	color: string;
	type: AttributeType;
	componentCategories: ComponentCategory[];
	attributeValues: AttributeValue[];
	suffix?: string;
	translations: Translations<{ name: string; description: string }>;
}

class AttributeApi extends EntityApi<Attribute> {
	constructor() {
		super(QueryKeys.attributes);
		this.getMultipleAttributes = this.getMultipleAttributes.bind(this);
	}

	async getValuesByAttribute({
		queryKey,
	}: QueryFunctionContext<[QueryKeys, UUID, QueryKeys]>) {
		const response = await httpClient.get<AttributeValue[]>(
			`${queryKey[0]}/${queryKey[1]}/${queryKey[2]}`
		);

		return response.data;
	}

	getMultipleAttributes({
		queryKey,
	}: QueryFunctionContext<[QueryKeys, UUID[]]>) {
		const requests = queryKey[1].map((id) =>
			httpClient.get<Attribute>(`${this.queryKey}/${id}`)
		);

		return Promise.all(requests).then((responses) =>
			responses.map((response) => response.data)
		);
	}
}

export default new AttributeApi();
